export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#2B6777] text-white py-16">
      <div className="max-w-content mx-auto px-6">

        {/* Pink CTA Button */}
        <div className="text-center mb-14">
          <a
            href="https://api.leadconnectorhq.com/widget/form/0ZsIY0jYLaF8aXm2FeXI"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-10 py-4 bg-[#D98CA3] hover:bg-[#c97a91] text-white text-lg font-bold rounded-2xl transition-all cursor-pointer whitespace-nowrap shadow-xl hover:shadow-2xl hover:scale-[1.02] transform"
          >
            Get My Free Proposal
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
          <p className="text-white/60 text-sm mt-4 flex items-center justify-center gap-2">
            <i className="ri-lock-line"></i>
            Exterior photos only. Private and secure. See Privacy Policy.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-heading font-bold mb-4">SnapWindows</h3>
            <p className="text-white/80 text-sm leading-relaxed mb-4">
              Premium window replacement. Zero pressure. Built on respect, transparency, and control.
            </p>
            <p className="text-white/50 text-xs leading-relaxed mb-6 flex items-start gap-2">
              <i className="ri-shield-check-line text-[#52AB98] mt-0.5 shrink-0"></i>
              <span>Exterior-only analysis. No in-home sales visits. Data protected.</span>
            </p>
            <div className="flex gap-4">
              <a
                href="#"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#how-it-works" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  How It Works
                </a>
              </li>
              <li>
                <a href="#our-work" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Our Work
                </a>
              </li>
              <li>
                <a href="#reviews" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Reviews
                </a>
              </li>
              <li>
                <a href="#faq" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li className="text-white/80 text-sm">Window Replacement</li>
              <li className="text-white/80 text-sm">Energy-Efficient Windows</li>
              <li className="text-white/80 text-sm">Custom Window Installation</li>
              <li className="text-white/80 text-sm">Window Repair</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-[#52AB98] mt-1"></i>
                <span className="text-white/80 text-sm">
                  Richmond, VA & Surrounding Areas
                </span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-[#52AB98] mt-1"></i>
                <a href="tel:+18043622555" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  (804) 362-2555
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-[#52AB98] mt-1"></i>
                <a href="mailto:Snapwindowsai@gmail.com" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Snapwindowsai@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Privacy Banner - NEW */}
        <div className="py-6 border-t border-white/10 text-center">
          <p className="text-white/60 text-sm flex items-center justify-center gap-2">
            <i className="ri-lock-line text-[#52AB98]"></i>
            <span>
              Your photos never leave our servers. Exterior-only. No third-party sharing.{' '}
              <a href="/privacy-policy" className="text-white/80 hover:text-white underline cursor-pointer">
                Privacy Policy
              </a>
            </span>
          </p>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm">
              © {currentYear} SnapWindows. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="/privacy-policy" className="text-white/60 hover:text-white transition-colors text-sm cursor-pointer">
                Privacy Policy
              </a>
              <a href="#terms" className="text-white/60 hover:text-white transition-colors text-sm cursor-pointer">
                Terms of Service
              </a>
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/60 hover:text-white transition-colors text-sm cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}